document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('lottery-form');
  if (!form) return;

  const submitButton = document.getElementById('lottery-submit');
  const message = document.getElementById('lottery-message');

  const lastNameInput =
    document.getElementById('lottery-last-name');
  const firstNameInput =
    document.getElementById('lottery-first-name');

  const apparelProductSelect =
    document.getElementById('apparel-product');
  const apparelSizePanel =
    document.getElementById('apparel-size-panel');
  const apparelSizeSelect =
    document.getElementById('apparel-size');

  let isSubmitting = false;

  // 商品選択時のみサイズを表示し、必須にする。
  function updateApparelSizePanel() {
    if (
      !apparelProductSelect ||
      !apparelSizePanel ||
      !apparelSizeSelect
    ) {
      return;
    }

    const isSelected = apparelProductSelect.value !== '';

    apparelSizePanel.hidden = !isSelected;
    apparelSizeSelect.disabled = !isSelected;
    apparelSizeSelect.required = isSelected;

    if (!isSelected) {
      apparelSizeSelect.value = '';
    }
  }

  if (apparelProductSelect) {
    apparelProductSelect.addEventListener(
      'change',
      updateApparelSizePanel
    );
  }

  updateApparelSizePanel();

  // 戻る操作などで復元された入力状態にも合わせる。
  window.addEventListener('pageshow', updateApparelSizePanel);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (isSubmitting) return;

    updateApparelSizePanel();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    // 姓・名の前後の空白を除去。
    data.last_name = String(data.last_name || '').trim();
    data.first_name = String(data.first_name || '').trim();

    // 空白だけの入力も防ぐ。
    if (!data.last_name || !data.first_name) {
      message.textContent = '姓と名をそれぞれ入力してください。';
      message.style.color = 'red';

      if (!data.last_name && lastNameInput) {
        lastNameInput.focus();
      } else if (!data.first_name && firstNameInput) {
        firstNameInput.focus();
      }

      return;
    }

    // 既存のGAS・シートに合わせ、氏名をまとめて送信。
    data.name = `${data.last_name} ${data.first_name}`;

    data.application_products =
      'YUTO HORIGOME × NIKE SB - AIR FORCE 1 "Iron Grey"';

    data.sneaker_size = data.sneaker_size || '';

    data.apparel_product = apparelProductSelect
      ? apparelProductSelect.value
      : '';

    data.apparel_size =
      data.apparel_product && apparelSizeSelect
        ? apparelSizeSelect.value
        : '';

    data.accepts_marketing = formData.has('accepts_marketing')
      ? 'true'
      : 'false';

    const storageKey = `lottery_${data.collection_handle}`;

    // 従来のブラウザ内の重複応募チェック。
    try {
      if (localStorage.getItem(storageKey)) {
        message.textContent = 'すでにご応募いただいています。';
        message.style.color = 'red';
        return;
      }
    } catch (error) {
      console.warn('応募履歴を読み込めませんでした。', error);
    }

    isSubmitting = true;
    submitButton.disabled = true;
    message.textContent = '';

    const buttonText = submitButton.querySelector('.btn-text');

    if (buttonText) {
      buttonText.textContent = '送信中...';
    }

    try {
      await fetch(
        'https://script.google.com/macros/s/AKfycbxgyiLe2P-As3k390_eyfryvYQkgF2lADxk5S9q2h76nEGKt7el053YMlPeYJ5nJx-TLA/exec',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'text/plain;charset=UTF-8',
          },
          body: JSON.stringify(data),
        }
      );

      // no-corsではGASの保存結果を読み取れないため、
      // この時点では保存成功の確認まではできない。
      try {
        localStorage.setItem(storageKey, '1');
      } catch (error) {
        console.warn('応募履歴を保存できませんでした。', error);
      }

      form.innerHTML = `
        <div class="lottery-success" role="status">
          <p>
            応募データを送信しました。<br>
            当選者様にはこちらからメールにてご連絡致します。
          </p>
        </div>
      `;
    } catch (error) {
      console.error('Lottery form submission error:', error);

      message.textContent =
        '通信エラーが発生しました。応募が届いている場合もあるため、再送前に店舗へお問い合わせください。';
      message.style.color = 'red';

      isSubmitting = false;
      submitButton.disabled = false;

      if (buttonText) {
        buttonText.textContent = '応募する';
      }
    }
  });
});
